import vMosso from './../../directive/mosso'

let _Vue = null

export default function install(Vue) {

    if (_Vue) return

    _Vue = Vue

    // 注册mosso上报指令
    Vue.directive('mosso', {bind: vMosso})
    
    // 实例注入
    Vue.mixin({
        beforeCreate() {
            const options = this.$options
            if (options.mosso) {
                this.$mosso = options.mosso
            } else if (options.parent && options.parent.$mosso) {
                this.$mosso = options.parent.$mosso
            }
        }
    })
}